import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getUserInfo } from '@/api/user' // 假设有一个获取用户信息的接口

export const useAuthStore = defineStore('auth', () => {
  const token = ref('') // 存储 token
  const userInfo = ref(null) // 存储用户信息

  // 设置 token
  const setToken = (newToken) => {
    token.value = newToken
    localStorage.setItem('token', newToken) // 持久化存储 token
  }

  // 清除 token
  const clearToken = () => {
    token.value = ''
    localStorage.removeItem('token')
  }

  // 获取用户信息
  const fetchUserInfo = async () => {
    try {
      const response = await getUserInfo()
      userInfo.value = response.data
    } catch (error) {
      console.error('获取用户信息失败:', error)
      clearToken()
    }
  }

  // 初始化 token
  const initToken = () => {
    const storedToken = localStorage.getItem('token')
    if (storedToken) {
      token.value = storedToken
    }
  }

  return {
    token,
    userInfo,
    setToken,
    clearToken,
    fetchUserInfo,
    initToken
  }
})
